import React, { useState } from "react";
import Button from "../Button";
import { post } from "../../lib/Fetching";
import DataFieldNameDropdown from "../products/DataFieldNameDropDown";

export default function AutoAddSampleCharges({ selectedSamples, laboratoryCompanyId }) {
  const [dataFieldNameId, setDataFieldNameId] = useState(null);

  const autoAddLedgerItems = () => {
    if (selectedSamples.length === 0) return;

    if (
      !confirm(
        "Are you sure you want to do this?  This will add samples to existing invoices with matching branch or create a new invoice for the branch."
      )
    )
      return;

    post("/invoicing/invoices/auto_add_ledger_items", {
      ledger_item_ids: selectedSamples.map((s) => s.ledger_item_id),
      data_field_name_id: dataFieldNameId,
      laboratory_company_id: laboratoryCompanyId,
    }).then((json) => {
      alert("Successfully auto added items to new or existing invoices.");
      reloadData();
    });
  };

  return (
    <div className="auto-add-sample-charges">
      <h2>Automatically Add Sample Charges to Invoices</h2>

      <p>
        Here you can automatically allocate sample charges to invoices based upon the
        registering branch and, optionally, split by a specific attribute of the sample.
      </p>
      <p>
        The system will try to move the samples onto an existing unfinalised invoice. If it
        cannot find one then it will create a new invoice for you.
      </p>

      <p>
        <b>All samples are automatically split by the registering branch.</b>
      </p>

      <p>
        Split by attribute?
        <DataFieldNameDropdown
          value={dataFieldNameId}
          onChange={(id) => setDataFieldNameId(id)}
          placeholder={"Split invoices by data field"}
        />
      </p>
      <p>
        <Button
          title="Auto Add Selected Items to Invoices"
          onClick={autoAddLedgerItems}
          disabled={selectedSamples.length === 0}
          deleting
          small
        />
      </p>
    </div>
  );
}
